export default {
  'product.error.over_maximum_quantity': 'Exceeded the maximum purchase limit per transaction',
  'product.error.sold_out': 'This product is sold out',
  'product.error.add_cart_fail': 'Failed to add to cart',
  'product.available_store': 'Available Stores',
  'product.all': 'All',
  'product.introduction': 'Product Introduction',
  'product.discount_period': 'Discount Period',
  'product.sale_period': 'Sale Period',
  'product.every_set': 'Per Set',
  'product.piece': 'Piece',
  'product.remain_count': 'Remaining Quantity',
  'product.limit_quantity': 'Available Quantity',
  'product.limit_unit': 'sets',
  'product.notice': 'Notice',
  'product.publisher.title': 'Publisher Information',
  'product.publisher.name': 'Ruiding Digital Co., Ltd.',
  'product.publisher.address': 'Address: 3F, No. 25, Section 4, Ren’ai Road, Da’an District, Taipei City',
  'product.publisher.manager': 'Manager: Chen Yan-Zhang',
  'product.publisher.tax_id': 'Unified Business Number: 42837620',
  'product.contract.title': 'Performance Guarantee',
  'product.contract.content.one': 'The amount collected from the sale of this voucher has been deposited into the issuer’s dedicated account at Yongfeng Commercial Bank for exclusive use, which means it is specifically for fulfilling the obligation to deliver goods or provide services.',
  'product.contract.content.two': 'The custody period starts from the electronic voucher sale date (based on the sale date stated on the voucher) and lasts for one year.',
  'product.return_guide': 'Return and Refund Guide',
  'product.shopping_guide': 'Shopping Instructions',
  'product.expired': 'This product has expired',
  'product.coming_soon': 'Coming Soon',
  'product.add_to_cart': 'Add to Cart',
  'product.ok': 'OK',
} as Record<string, string>;
